import React, { useState, useEffect, useRef } from "react";
import { IoMdCart } from "react-icons/io";
import { useCart } from "../CartContext";
// import LanguageHandler from "./LanguageHandler";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { _get } from "../services/apiClient";
import { jwtDecode } from "jwt-decode";
import { isQrEntry } from "../helper/isQrEntry";
import { useTranslation } from "react-i18next";
import LanguageHandler from "./LanguageHandlers";
import { formatNumber } from "../helper/formatNumber";

import axios from "axios";
import Orders from "./Orders";

function CartSection({
  loggedIn,
  setLoggedIn,
  form,
  setForm,
  phoneNumber,
  setPhoneNumber,
  pageVisible,
  setPageVisible,
  ordersVisible,
  SetOrdersVisible,
  isphoneNumber,
}) {
  const { totalPrice } = useCart();
  const { itemQuantities } = useCart();
  // Count unique items with quantity > 0
  const totalQuantity = Object.values(itemQuantities).filter(
    (item) => item.quantity > 0,
  ).length;
  // console.log(totalPrice);
  const [showPlacedOrderSummary, setShowPlacedOrderSummary] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [name, setName] = useState("");
  const [userId, setUserId] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  // State to track QR mode
  const [isQrMode, setIsQrMode] = useState(false);

  // Check QR mode on mount and when navigating
  useEffect(() => {
    const checkQrMode = () => {
      const qrMode = isQrEntry();
      setIsQrMode(qrMode);
    };

    checkQrMode();

    // Listen for storage changes
    window.addEventListener("storage", checkQrMode);

    // Also check periodically in case localStorage changes in same tab
    const interval = setInterval(checkQrMode, 500);

    return () => {
      window.removeEventListener("storage", checkQrMode);
      clearInterval(interval);
    };
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);

      if (decoded?.id) {
        setLoggedIn(true);
        setUserId(decoded.id);

        const fetchUserDetails = async () => {
          try {
            const res = await _get(`/auth/me/${decoded.id}`);
            if (res.data.success) {
              setName(res.data.user.name || "");
              setPhoneNumber(res.data.user.phoneNumber || "");
            }
          } catch (err) {
            console.error("Error fetching user:", err);
          }
        };

        fetchUserDetails();
      }
    } catch (err) {
      console.error("Invalid token:", err);
      setLoggedIn(false);
    }
  }, [setLoggedIn, setPhoneNumber]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setLoggedIn(false);
    SetOrdersVisible(false);
    setPageVisible(false);
    navigate("/");
    window.location.reload();
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-orange-100/50 shadow-sm">
      <div className="w-full px-3 sm:px-8 md:px-12 lg:px-16 xl:px-20">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center gap-3 group">
              <img
                alt="Logo"
                className="h-7 sm:h-9 md:h-10 w-auto transition-transform duration-300 group-hover:scale-105"
                src={window.location.origin + "/img/logo black.png"}
              />
            </a>
          </div>

          {/* Middle Section */}
          <div className="flex-1"></div>

          {/* Right Section - User & Cart */}
          <div className="flex items-center gap-2 sm:gap-4 md:gap-6">
            <LanguageHandler />
            {/* User Icon - Only show for non-QR entry and when login is enabled */}
            {!isQrMode && process.env.REACT_APP_LOGIN_ENABLED === 'true' && (
              <div className="relative" ref={dropdownRef}>
                {!loggedIn ? (
                  <button
                    onClick={() => navigate("/login")}
                    className="flex flex-row-reverse items-center gap-2 px-2 py-2 sm:px-4 sm:py-2 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg font-medium text-sm shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                  >
                    <FaUserCircle className="text-xl" />
                    <span className="hidden sm:inline">{t("login")}</span>
                  </button>
                ) : (
                  <>
                    <FaUserCircle
                      onClick={() => setShowDropdown(!showDropdown)}
                      className="text-xl sm:text-2xl md:text-3xl cursor-pointer text-teal-600 hover:text-teal-700 transition-all duration-300"
                    />
                    {showDropdown && (
                      <div className="absolute top-full right-0 mt-2 z-50">
                        <div className="bg-white rounded-lg shadow-lg py-2 min-w-[160px] border border-gray-100">
                          <div className="px-4 py-2 text-sm font-semibold text-gray-700 border-b border-gray-100">
                            {t("hi")}, {name}
                          </div>
                          <button
                            className="w-full text-start px-4 py-2 text-sm text-gray-700 hover:bg-orange-50 transition-colors"
                            onClick={() => {
                              navigate("/orders");
                              setShowDropdown(false);
                            }}
                          >
                            {t("myOrders")}
                          </button>
                          <button
                            className="w-full text-start px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                            onClick={() => {
                              handleLogout();
                              setShowDropdown(false);
                            }}
                          >
                            {t("logout")}
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Cart Icon */}
            <div
              className="relative flex items-center cursor-pointer group p-1.5 sm:p-2 rounded-xl hover:bg-orange-50 transition-colors duration-300"
              onClick={() => {
                if (isQrMode) {
                  navigate("/qr-cart");
                } else {
                  navigate("/cart");
                }
              }}
            >
              <IoMdCart className="text-orange-600 text-xl sm:text-2xl md:text-3xl transition-transform duration-300 group-hover:scale-110" />
              {totalQuantity > 0 && (
                <div className="absolute -top-0.5 sm:-top-1 inset-inline-end-0 translate-x-1/2 bg-gradient-to-br from-orange-500 to-red-500 text-white text-[10px] sm:text-xs font-bold rounded-full h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 flex items-center justify-center shadow-lg animate-pulse">
                  {formatNumber(totalQuantity, i18n.language)}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default CartSection;
